interface UIPayload {
    message?: string;
    title?: string;
    duration?: number;
    showSpinner?: boolean;
    type?: "success" | "info" | "error" | "warning";
}

interface OverlayDataInterface {
    message?: string;
    showSpinner?: boolean;
}

interface NotificationDataInterface {
    title?: string;
    message?: string;
    type?: "info" | "success" | "error" | "warning";
    duration?: number;
}

export type UIAction =
    | { type: "SHOW_LOCK_OVERLAY"; payload: UIPayload }
    | { type: "HIDE_LOCK_OVERLAY" }
    | { type: "SHOW_NOTIFICATION_OVERFLOW"; payload: UIPayload }
    | { type: "HIDE_NOTIFICATION_OVERFLOW" };

interface UIState {
    lockOverlay: boolean;
    lockOverlayData: OverlayDataInterface;
    notificationOverflow: boolean;
    notificationOverflowData: NotificationDataInterface;
}

const initialState: UIState = {
    lockOverlay: false,
    lockOverlayData: {
        message: "",
        showSpinner: false,
    },
    notificationOverflow: false,
    notificationOverflowData: {
        title: "",
        message: "",
        type: "info",
        duration: 5000,
    },
};

const ui = (state = initialState, action: UIAction) => {
    switch (action.type) {
        case "SHOW_LOCK_OVERLAY":
            return {
                ...state,
                lockOverlay: true,
                lockOverlayData: {
                    message: action.payload.message,
                    showSpinner: action.payload.showSpinner,
                },
            };
        case "HIDE_LOCK_OVERLAY":
            return {
                ...state,
                lockOverlay: false,
                lockOverlayData: { message: "" },
            };
        case "SHOW_NOTIFICATION_OVERFLOW":
            return {
                ...state,
                notificationOverflow: true,
                notificationOverflowData: {
                    message: action.payload.message,
                    title: action.payload.title,
                    duration: action.payload.duration,
                    type: action.payload.type,
                },
            };
        case "HIDE_NOTIFICATION_OVERFLOW":
            return {
                ...state,
                notificationOverflow: false,
                notificationOverflowData: initialState.notificationOverflowData,
            };
        default:
            return state;
    }
};

export default ui;
